<kanzi-progress-bar
  [show]="(pending$ | async) || false"
  [height]="'5px'"
></kanzi-progress-bar>
<kanzi-ui-main-card
  title="{{ 'locations.title' | translate }}"
  description="{{ 'locations.description' | translate }}"
>
  <ng-template kTemplate="rightTopContent">
    <button
      pButton
      pRipple
      type="button"
      label="{{ 'locations.create' | translate }}"
      [routerLink]="['../create']"
      class="p-button-raised mr-2 mb-2"
      icon="pi pi-plus"
      pTooltip="{{ 'locations.create_tooltip' | translate }}"
      tooltipPosition="bottom"
    ></button>
  </ng-template>
  <kanzi-dynamic-table
    [pending]="(pending$ | async) || false"
    [configs]="configTable"
    [colSource]="cols"
    [dataSource]="(locations$ | async)!"
    [customer]="customerSelected$ | async"
    [filters]="filters"
    (paginationEvent)="pagination($event)"
    (editEvent)="edited($event)"
    (selectEvent)="selected($event)"
    (deleteEvent)="deletes($event)"
    (filterEvent)="activeFilter($event)"
    (clearEvent)="restoreData($event)"
    (searchCustomFilter)="FilterData($event)"
    (sortCustomField)="FilterData($event)"
  ></kanzi-dynamic-table>
</kanzi-ui-main-card>
